export default "__VITE_ASSET__BaydZHeI__"